import { Outlet } from 'react-router';

export default function MainLayout() {
  return (
    <>
      <div className="flex h-screen flex-col">
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </>
  );
}
